// Logo Tedarikci sayfasi. Grid + detay (ResourceListPage generic).
import { ResourceListPage, ResourceConfig, FieldSpec } from '../components/ResourceListPage';
import { Supplier, emptySupplier } from '../types';
import { getSuppliers, saveSupplier } from '../api/suppliers';

const columns = [
  { dataField: 'code', caption: 'Kod', width: 130 },
  { dataField: 'title', caption: 'Unvan', width: 'auto' },
  { dataField: 'city', caption: 'Sehir', width: 120 },
  { dataField: 'phone1', caption: 'Telefon', width: 130 },
  { dataField: 'email', caption: 'E-posta', width: 180 },
  {
    dataField: 'isActive', caption: 'Durum', width: 90, alignment: 'center' as const,
    cellRender: (d: any) => (d.data.isActive ? 'Aktif' : 'Pasif'),
  },
];

const fields: FieldSpec[] = [
  { field: 'code', label: 'Kod', required: true, tab: 'Genel' },
  { field: 'title', label: 'Unvan', required: true, tab: 'Genel' },
  { field: 'title2', label: 'Unvan 2', tab: 'Genel' },
  { field: 'paymentGroup', label: 'Odeme Grubu', tab: 'Genel' },
  { field: 'tradingGroup', label: 'Ticari Grup', tab: 'Genel' },
  { field: 'isActive', label: 'Aktif', editor: 'check', tab: 'Genel' },

  { field: 'address1', label: 'Adres 1', colSpan: 2, tab: 'Adres' },
  { field: 'address2', label: 'Adres 2', colSpan: 2, tab: 'Adres' },
  { field: 'city', label: 'Sehir', tab: 'Adres' },
  { field: 'zipCode', label: 'Posta Kodu', tab: 'Adres' },
  { field: 'countryCode', label: 'Ulke Kodu', tab: 'Adres' },
  { field: 'country', label: 'Ulke', tab: 'Adres' },
  { field: 'phone1', label: 'Telefon 1', tab: 'Adres' },
  { field: 'phone2', label: 'Telefon 2', tab: 'Adres' },
  { field: 'fax', label: 'Faks', tab: 'Adres' },
  { field: 'email', label: 'E-posta', tab: 'Adres' },

  { field: 'specode1', label: 'Ozel Kod 1', tab: 'Ozel Kodlar' },
  { field: 'specode2', label: 'Ozel Kod 2', tab: 'Ozel Kodlar' },
  { field: 'specode3', label: 'Ozel Kod 3', tab: 'Ozel Kodlar' },
  { field: 'specode4', label: 'Ozel Kod 4', tab: 'Ozel Kodlar' },
  { field: 'specode5', label: 'Ozel Kod 5', tab: 'Ozel Kodlar' },
];

const config: ResourceConfig<Supplier> = {
  keyExpr: 'code',
  columns,
  fields,
  load: (onlyActive) => getSuppliers({ onlyActive }),
  save: (s) => saveSupplier(s),
  newItem: emptySupplier,
  headerLabel: (s) => (s.code ? `${s.code} — ${s.title}` : 'Yeni Tedarikci'),
  hasActiveFilter: true,
};

export default function LogoSuppliersPage() {
  return <ResourceListPage config={config} />;
}
